var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { attrs: { id: "list-tasks" } }, [
    _c("li", [
      _c("div", { staticClass: "oblea", on: { click: _vm.selectItem } }, [
        _c("div", { attrs: { id: "imagenProductoContainer" } }, [
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.item.showCheck,
                expression: "item.showCheck"
              }
            ],
            attrs: { id: "check", src: "/dist/icon-check.png" }
          }),
          _vm._v(" "),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.item.ManejaStock,
                expression: "item.ManejaStock"
              }
            ],
            attrs: { id: "semaforo" + _vm.semaforoVal }
          }),
          _vm._v(" "),
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.imagenProducto != null,
                expression: "imagenProducto != null"
              }
            ],
            attrs: {
              id: "imagenProducto",
              src: _vm.imagenProducto,
              title: _vm.item.Nombre
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.esProducto,
                expression: "esProducto"
              }
            ],
            staticClass: "fh cc",
            staticStyle: {
              "font-size": "10px",
              "font-weight": "500",
              color: "rgb(194, 126, 43)",
              "margin-top": "6px",
              "margin-bottom": "-6px"
            }
          },
          [_vm._v("Cod " + _vm._s(_vm.item.Codigo))]
        ),
        _vm._v(" "),
        _c("p", { attrs: { id: "labelProducto" } }, [
          _vm._v(_vm._s(_vm.item.Nombre))
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-88dcf5fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88dcf5fe","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/realizarPedido/itemRealizarPedido.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-88dcf5fe","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/realizarPedido/itemRealizarPedido.vue
// module chunks = 0